<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter helpdesk-form">
      <iframe class="clickup-embed" src="https://sharing.clickup.com/b/h/6-13759881-2/257656ecf5d9951" 
      onwheel="" width="100%" height="100%" style="background: transparent; border: 1px solid #ccc;"/>
  </div>
</template>

<script>
import mixins from "../../../../Mixins.js";

export default ({
  mixins: [mixins],
})
</script>
